import { setWishlistEmailGiven, setWishlistPopupSkipped } from './wishlistStore.ts';

/** Popup globale (markup dans PublicLayout.ts, présente sur toutes les pages
 * publiques) — ouverte via la fonction `open` retournée, scopée aux `productIds`
 * fournis à l'appel (un seul produit depuis un cœur, ou toute la liste depuis
 * /liste-de-souhaits). */
export function initWishlistPopup(): { open: (productIds: string[]) => void } {
  const popup = document.getElementById('wishlist-popup');
  const backdrop = document.getElementById('wishlist-popup-backdrop');
  const closeBtn = document.getElementById('wishlist-popup-close');
  const form = document.getElementById('wishlist-popup-form') as HTMLFormElement | null;
  const errorEl = document.getElementById('wishlist-popup-error');

  let pendingProductIds: string[] = [];

  function noop(): void {}

  if (!popup || !backdrop || !closeBtn || !form) return { open: noop };

  function close(): void {
    popup!.classList.remove('is-open');
    backdrop!.classList.remove('is-open');
    popup!.setAttribute('aria-hidden', 'true');
    // Fermée (croix, fond, Échap, ou après soumission réussie) — dans tous les
    // cas on ne la reproposera plus (voir hasSkippedWishlistPopup).
    setWishlistPopupSkipped();
  }

  function open(productIds: string[]): void {
    pendingProductIds = productIds;
    popup!.classList.add('is-open');
    backdrop!.classList.add('is-open');
    popup!.setAttribute('aria-hidden', 'false');
  }

  closeBtn.addEventListener('click', close);
  backdrop.addEventListener('click', close);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popup!.classList.contains('is-open')) close();
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (errorEl) errorEl.hidden = true;

    const email = (new FormData(form).get('email') as string | null)?.trim();
    if (!email) return;

    try {
      const res = await fetch('/api/liste-de-souhaits/inscription', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, productIds: pendingProductIds }),
      });
      if (!res.ok) throw new Error('Échec de l\'inscription');

      setWishlistEmailGiven();
      form.reset();
      close();
    } catch {
      if (errorEl) errorEl.hidden = false;
    }
  });

  return { open };
}
